export default {"src":"/_next/static/media/shieldWithCheckmark_40.127bf98d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};